import React from "react";
import "./DrShrutiPage.css";
const DrShrutiPage = () => {
  
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "MedicalOrganization",
    name: "Krisara Gastro and Liver Clinic",
    url: "https://krisaragastro.com/",
    logo: "https://i.ibb.co/HDcnBZt3/Rectangle-76.png",
    image: "https://i.ibb.co/HDcnBZt3/Rectangle-76.png",
    telephone: "+91 7569541532",
    email: "gastro@krisara.com",
    address: {
      "@type": "PostalAddress",
      streetAddress:
        "3rd Floor, Fairmount Square, Pet Basheerabad, Quthbullapur, Kompally",
      addressLocality: "Hyderabad",
      addressRegion: "Telangana",
      postalCode: "500014",
      addressCountry: "IN",
    },
    sameAs: [
      "https://www.facebook.com/krisaragastro",
      "https://www.instagram.com/krisaragastro",
    ],
  };

  return (
    <div className="drshruti-page">
      {/* Hero Section */}
      {/* About Section */}
      <section className="drshruti-about">
        <div className="drshruti-about-container">
          <h2 className="drshruti-about-title">About Dr. Shruti Sagar</h2>
          <p className="drshruti-about-text">
            Dr. B. Shruti Sagar stands as one of Hyderabad's most trusted and
            accomplished gastroenterologists, bringing over 8 years of
            specialized expertise in digestive health and liver diseases to
            patients across Telangana. Currently serving as Associate Consultant
            at the prestigious Yashoda Hospitals, Secunderabad, Dr. Sagar has
            established Krisara Gastro and Liver Clinic in Kompally to provide
            world-class, personalized care closer to home.
            With a patient-centric approach rooted in evidence-based medicine,
            Dr. Sagar has transformed the lives of thousands of patients,
            helping them overcome complex gastrointestinal and hepatological
            conditions with compassion, precision, and cutting-edge treatment
            methods.</p>
        </div>
      </section>
    </div>
  );
};
export default DrShrutiPage;